var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [_c('v-data-table', {
    staticClass: "v-data-table--default",
    attrs: {
      "items": _vm.boards,
      "headers": _vm.headers,
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "mobile-breakpoint": "768"
    },
    on: {
      "click:row": _vm.rows
    },
    scopedSlots: _vm._u([{
      key: "item.no",
      fn: function fn(_ref) {
        var item = _ref.item;
        return _c('span', {}, [item.isNotice ? _c('v-icon', {
          attrs: {
            "color": "yellow darken-2"
          }
        }, [_vm._v("mdi-alert-circle-outline")]) : _c('span', [_vm._v(_vm._s((_vm.page - 1) * _vm.limit + +_vm.boards.filter(function (noti) {
          return !noti.isNotice;
        }).indexOf(item) + 1))])], 1);
      }
    }, {
      key: "item.subject",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return _c('span', {
          staticClass: "d-block font-weight-medium text-truncate"
        }, [_c('v-row', [_c('v-col', {
          staticClass: "pr-1",
          attrs: {
            "cols": "auto"
          }
        }, [_vm._v(_vm._s(item.subject))]), item.isComment ? _c('v-col', {
          staticClass: "pl-1"
        }, [_vm._v("(" + _vm._s(item.commentCount) + ")")]) : _vm._e()], 1)], 1);
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")))]);
      }
    }])
  }, [_c('span', {
    attrs: {
      "slot": "item.writer.name"
    },
    slot: "item.writer.name"
  }, [_vm._v("관리자")])])], 1), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-divider'), _c('div', {
    staticClass: "grey lighten-4 pa-12px py-md-20px"
  }, [_c('div', {
    staticClass: "mw-500px mx-auto"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-select', {
    staticClass: "white mw-md-180px",
    attrs: {
      "items": _vm.searchKeyItems,
      "item-text": "text",
      "item-value": "value",
      "outlined": "",
      "hide-details": "",
      "dense": ""
    },
    on: {
      "input": function input(value) {
        return _vm.filter.searchValue = value ? _vm.filter.searchValue : '';
      }
    },
    model: {
      value: _vm.filter.searchKey,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchKey", $$v);
      },
      expression: "filter.searchKey"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "white",
    attrs: {
      "outlined": "",
      "hide-details": "",
      "disabled": !_vm.filter.searchKey
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--input w-80px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('search', false);
      }
    }
  }, [_vm._v("검색")])], 1)], 1)], 1)], 1)], 1)]), _c('v-divider')], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }